<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Secretly Smitten</title><link href="default.css" rel="stylesheet" type="text/css"/><link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe.page-template+xml"/>
<p class="ct" id="p0007-01-0"><a id="page7">C<span class="small">ONTENTS</span></a></p><a id="page7">
<p class="ser"><img alt="ontents" id="p0007-d6e12" src="images/9781401687137_IN_0007_002.jpg" style="max-width: 100%;"/></p>
</a><p class="cct" id="p0007-03-1"><a id="page7"></a><a href="#/chapter51" id="a_1"><i>Acknowledgments</i></a></p>
<p class="cct" id="p0008-04-2"><a href="#/chapter17" id="a_2"><i>Chapter 1</i></a></p>
<p class="cct" id="p0009-04-2"><span href="#/chapter18" id="a_3" title="Link target outside of Sample"><i>Chapter 2</i></span></p>
<p class="cct" id="p00010-04-3"><span href="#/chapter19" id="a_4" title="Link target outside of Sample"><i>Chapter 3</i></span></p>
<p class="cct" id="p00011-04-2"><span href="#/chapter20" id="a_5" title="Link target outside of Sample"><i>Chapter 4</i></span></p>
<p class="cct" id="p00011-04-3"><span href="#/chapter21" id="a_55" title="Link target outside of Sample"><i>Chapter 5</i></span></p>
<p class="cct" id="p00012-04-2"><span href="#/chapter22" id="a_6" title="Link target outside of Sample"><i>Chapter 6</i></span></p>
<p class="cct" id="p00013-04-2"><span href="#/chapter23" id="a_7" title="Link target outside of Sample"><i>Chapter 7</i></span></p>
<p class="cct" id="p00014-04-2"><span href="#/chapter24" id="a_8" title="Link target outside of Sample"><i>Chapter 8</i></span></p>
<p class="cct" id="p0015-04-2"><span href="#/chapter25" id="a_9" title="Link target outside of Sample"><i>Chapter 9</i></span></p>
<p class="cct" id="p00016-04-2"><span href="#/chapter26" id="a_10" title="Link target outside of Sample"><i>Chapter 10</i></span></p>
<p class="cct" id="p00018-05-3"><span href="#/chapter50" id="a_12" title="Link target outside of Sample"><i>Reading Group Guide</i></span></p>
<p class="cct" id="p00019-06-4"><span href="#/excerpt" id="a_13" title="Link target outside of Sample"><i>Excerpt from</i> The Scent of Rain</span></p>
<p class="cct" id="p00020-06-4"><span href="#/chapter55" id="a_14" title="Link target outside of Sample"><i>Author Bio</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?38650838